/**
 * @generated SignedSource<<fe0ef38e79123ef66cd2bc91c95a6f4b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FilterOperator = "BEGINS_WITH" | "CONTAINS" | "EQ" | "GT" | "GTE" | "IN" | "LT" | "LTE" | "NEQ" | "NOT_CONTAINS" | "%future added value";
export type OrderByDirection = "ASC" | "DESC" | "%future added value";
export type DrawingSetListInput = {
  filter?: DrawingSetListFilter | null | undefined;
  orderBy?: DrawingSetListOrder | null | undefined;
};
export type DrawingSetListFilter = {
  projectId?: Filter | null | undefined;
};
export type Filter = {
  operator: FilterOperator;
  value: string;
};
export type DrawingSetListOrder = {
  createdAt?: OrderByDirection | null | undefined;
  name?: OrderByDirection | null | undefined;
};
export type getDrawingSetListQuery$variables = {
  input: DrawingSetListInput;
};
export type getDrawingSetListQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"drawingSetListFragment">;
};
export type getDrawingSetListQuery = {
  response: getDrawingSetListQuery$data;
  variables: getDrawingSetListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "getDrawingSetListQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "drawingSetListFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "getDrawingSetListQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DrawingSetConnection",
        "kind": "LinkedField",
        "name": "drawingSetList",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DrawingSetEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DrawingSet",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdById",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "currentJobId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fileName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "previousJobId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "measureUnit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "tags",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "versionDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "projectId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "filters": [
          "input"
        ],
        "handle": "connection",
        "key": "drawingSetListFragment___drawingSetList",
        "kind": "LinkedHandle",
        "name": "drawingSetList"
      }
    ]
  },
  "params": {
    "cacheID": "a8ed9aafd8a0c00f9683466c63da8440",
    "id": null,
    "metadata": {},
    "name": "getDrawingSetListQuery",
    "operationKind": "query",
    "text": "query getDrawingSetListQuery(\n  $input: DrawingSetListInput!\n) {\n  ...drawingSetListFragment_2VV6jB\n}\n\nfragment drawingSetConnectionFragment on DrawingSetConnection {\n  edges {\n    cursor\n    node {\n      ...drawingSetFragment\n      id\n    }\n  }\n  pageInfo {\n    ...pageInfoFragment\n  }\n}\n\nfragment drawingSetFragment on DrawingSet {\n  id\n  createdAt\n  updatedAt\n  createdById\n  currentJobId\n  fileName\n  previousJobId\n  status\n  name\n  measureUnit\n  tags\n  versionDate\n  projectId\n}\n\nfragment drawingSetListFragment_2VV6jB on Query {\n  drawingSetList(input: $input) {\n    edges {\n      cursor\n      node {\n        ...drawingSetFragment\n        id\n        __typename\n      }\n    }\n    ...drawingSetConnectionFragment\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment pageInfoFragment on PageInfo {\n  startCursor\n  endCursor\n  hasNextPage\n  hasPreviousPage\n}\n"
  }
};
})();

(node as any).hash = "6f5101626360e86c4301ed36471c4b22";

export default node;
